// extracted by mini-css-extract-plugin
export default {"emptyContainer":"ViewNoData_emptyContainer__i7dZX"};